import { SortInput } from 'components/Table'
import { ViewportSortBy } from './types'

export const DEFAULT_SORT: SortInput<ViewportSortBy> = {
  by: 'updatedAt',
  direction: 'desc',
} as const

export const SORTABLE_COLUMNS: ViewportSortBy[] = ['minimumWidth', 'name', 'updatedAt']
